"use client";

import { c as _c } from "react/compiler-runtime";
import { memo, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { A11y, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { NextGenToken } from "@/entities/INextgen";
import { NextGenTokenImage } from "@/components/nextGen/collections/nextgenToken/NextGenTokenImage";
import SwiperAutoplayButton from "./SwiperAutoplayButton";
import { useTokenSlideshow } from "./useTokenSlideshow";
import { useSlideshowConfig } from "./useSlideshowConfig";
import { useSlideshowAutoplay } from "./useSlideshowAutoplay";

// Memoized image component to prevent re-downloads on parent re-renders
const MemoizedTokenImage = memo(NextGenTokenImage);
interface TokenSlideshowProps {
  readonly collectionId: number;
  readonly initialTokens?: NextGenToken[];
}
export default function TokenSlideshow(t0) {
  const $ = _c(18);
  const {
    collectionId,
    initialTokens: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialTokens = t2;
  const swiperContainerRef = useRef(null);
  const {
    displayTokens,
    onSlideChange
  } = useTokenSlideshow(collectionId, initialTokens);
  const {
    slidesPerView
  } = useSlideshowConfig();
  const {
    isInViewport,
    setSwiperInstance
  } = useSlideshowAutoplay(swiperContainerRef);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [Navigation, A11y, Autoplay];
    t4 = {
      delay: 3000,
      disableOnInteraction: false
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = Math.min(slidesPerView, displayTokens.length);
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      clickable: true
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== onSlideChange) {
    t7 = swiper => {
      onSlideChange(swiper.realIndex);
    };
    $[5] = onSlideChange;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== displayTokens.length || $[8] !== isInViewport) {
    t8 = displayTokens.length > 1 && <SwiperAutoplayButton isInViewport={isInViewport} />;
    $[7] = displayTokens.length;
    $[8] = isInViewport;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== displayTokens) {
    t9 = displayTokens.map(_temp);
    $[10] = displayTokens;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== setSwiperInstance || $[13] !== t5 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <Row><Col><div ref={swiperContainerRef}><Swiper modules={t3} autoplay={t4} initialSlide={2} spaceBetween={20} slidesPerView={t5} navigation={true} centeredSlides={true} pagination={t6} onSwiper={setSwiperInstance} onSlideChange={t7}>{t8}{t9}</Swiper></div></Col></Row>;
    $[12] = setSwiperInstance;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
function _temp(token, index) {
  return <SwiperSlide key={`${token.id}-${index}`} className="pt-4 pb-4 unselectable"><MemoizedTokenImage token={token} info_class="font-smaller" /></SwiperSlide>;
}